import { FC } from 'react';
import SessionsCalendar from 'components/SessionsCalendar';
import ReminderSettings from 'components/EmailReminderSettings/ReminderSettings';
import Text from 'components/core/Text';
import { Wrapper, Section } from './styles';

const SchedulePage: FC = () => {
  return (
    <div>
      <Wrapper>
        <Section>
          <Text variant="sectionHeader" transform="uppercase" mb={5}>
            Your training schedule
          </Text>
          <SessionsCalendar />
        </Section>
      </Wrapper>
      <Wrapper>
        <Section>
          <ReminderSettings />
        </Section>
      </Wrapper>
    </div>
  );
};

export default SchedulePage;
